import React, { useState } from "react";
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import { useHistory } from "react-router";
import settings from "../../config/settings";
import { handleApiError } from "../../session/session-expire";

const ChatDeleteAllConfirmation = ({
  isDeleteAllConfirmationOpen,
  setIsDeleteAllConfirmationOpen,
  handleSaveHistory,
  handleClearConversion
}) => {
  const history = useHistory();
  const [isDeleteChatLoading, setIsDeleteChatLoading] = useState(false);
  const [TOKEN] = useState(localStorage.getItem("access_token"));
  const [user_id] = useState(localStorage.getItem("userId"));


  const handleDelete = async () => {
    try {
      setIsDeleteChatLoading(true);
      const response = await axios.delete(
        `${settings.serverUrl}/history/delete_all`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${TOKEN}`,
          },
          data: {
            user_id: user_id
          },
        }
      );
      console.log("Delete response:", response);
      if(response?.status){
        setIsDeleteAllConfirmationOpen(false);
        handleSaveHistory(null, true);
        handleClearConversion();
      }
    } catch (error) {
      handleApiError(error, history);
      if (error.response) {
        console.error("API Error:", error.response.data);
      } else if (error.request) {
        console.error("No Response:", error.request);
      } else {
        console.error("Error:", error.message);
      }
    } finally {
      setIsDeleteChatLoading(false);
    }
  };

  return (
    <CModal
      alignment="center"
      scrollable
      show={isDeleteAllConfirmationOpen}
      onClose={() => setIsDeleteAllConfirmationOpen(!isDeleteAllConfirmationOpen)}
      size="md"
    >
      <CModalHeader closeButton>
        <CModalTitle>Are you sure you want to delete all chat history?</CModalTitle>
      </CModalHeader>
      <CModalBody>
        The history of this chat session will permanently removed.
      </CModalBody>
      <CModalFooter>
        <CButton color="primary" onClick={handleDelete}>
          {isDeleteChatLoading ? <CircularProgress size={20} /> : "Delete"}
        </CButton>{" "}
        <CButton
          color="secondary"
          onClick={() => setIsDeleteAllConfirmationOpen(!isDeleteAllConfirmationOpen)}
        >
          Cancel
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default ChatDeleteAllConfirmation;
